<template>
  <div>
    <div
      class="page-wrapper"
      :class="layout.settings.sidebar.type"
    >
      <Header
        @clicked="sidebar_toggle"
        @rightclicked="rightsidebar_toggle"
        @mobileclicked="mobiletoggle_toggle"
      />
      <div
        class="page-body-wrapper"
        :class="layout.settings.sidebar.body_type"
      >
        <div
          class="page-sidebar"
          :class="[{ open : sidebar_toggle_var }, layout.settings.sidebar_backround]"
          :sidebar-layout="layout.settings.sidebar_setting"
        >
          <Sidebar />
        </div>
        <div class="page-body">
          <transition
            name="fadeIn"
            enter-active-class="animated fadeIn"
          >
            <router-view class="view" />
          </transition>
        </div>
        <Footer />
      </div>
    </div>

    <b-modal
      id="modal-feedback-form"
      centered
      :title="$t('body.dstkSorusu')"
      :hide-footer="true"
      class="theme-modal"
    >
      <form @submit.prevent="sendFeedback">
        <div class="mb-3">
          <label for="feedbackText">{{ $t('body.mracitiniz') }}</label>
          <textarea
            id="feedbackText"
            v-model="feedBackText"
            class="form-control"
            rows="5"
            required
          />
        </div>
        <div class="mb-3">
          <button
            type="submit"
            class="btn btn-primary"
          >
            {{ $t('body.gndr') }}
          </button>
        </div>
      </form>
    </b-modal>


    <b-modal
      id="modal-request-create"
      centered
      :title="$t('body.soruYarat')"
      hide-footer
      class="theme-modal"
    >
      <NewRequestPopupContent @needOtherProfile="needOtherProfile($event)" />
    </b-modal>

    <b-modal
      id="modal-change-account"
      centered
      :hide-footer="true"
      :title="$t('body.profilSeimi')"
      class="theme-modal"
    >
      <ChangeAccountPopup
        :key="needPopupKey"
        :need-profiles="needProfiles"
        :company="company"
      />
    </b-modal>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Header from './header'
import Sidebar from './sidebar'
import Footer from './footer'
import {sendFeedbackRequest, userSetFCMToken} from "@/repositories/GeneralDataRepository";
import {getBrowserInfo} from "@/repositories/Utils";
import NewRequestPopupContent from "@/components/dashboard/NewRequestPopupContent.vue";
import ChangeAccountPopup from "@/pages/scc/account/ChangeAccountPopup.vue";

export default {
  name: 'Mainpage',
  // props:['sidebar_toggle_var'],
  components: {
    ChangeAccountPopup,
    NewRequestPopupContent,
    Header,
    Sidebar,
    Footer,
  },
  data() {
    return {
      rightsidebar_toggle_var: false,
      mobileheader_toggle_var: false,
      sidebar_toggle_var: false,
      horizontal_Sidebar: true,
      resized: false,
      feedBackText: '',
      needProfiles: []
    }
  },
  computed: {
    ...mapState({
      menuItems: state => state.menu.data,
      layout: state => state.layout.layout,
      user: state => state.auth.user,
      profile: state => state.auth.profile,
      company: state => state.auth.company,
      token: state => state.auth.token,
      sectorAdded: state => state.auth.sectorAdded,
      userPackageStatus: state => state.auth.userPackageStatus,
    }),
    needPopupKey() {
      return this.needProfiles.join(",") + "-" + Math.random();
    },
  },
  watch: {
    '$route'() {
      this.menuItems.filter(items => {
        if (items.path === this.$route.path)
          this.$store.dispatch('menu/setActiveRoute', items)
        if (!items.children) return false
        items.children.filter(subItems => {
          if (subItems.path === this.$route.path)
            this.$store.dispatch('menu/setActiveRoute', subItems)
          if (!subItems.children) return false
          subItems.children.filter(subSubItems => {
            if (subSubItems.path === this.$route.path)
              this.$store.dispatch('menu/setActiveRoute', subSubItems)
          })
        })
      });

      this.$bvModal.hide('modal-request-create');
    },
    sidebar_toggle_var: function () {
      this.resized = (this.width <= 991) ? !this.sidebar_toggle_var : this.sidebar_toggle_var
    },
    sectorAdded() {
      this.checkSectorUpdateNeeded();
    },
    userPackageStatus() {
      this.checkSectorUpdateNeeded();
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    this.resized = this.sidebar_toggle_var;
    this.$store.dispatch('layout/set');
    this.$messaging.getToken({vapidKey: 'BCLXYN1MfI6myGPYWqBKBIwdprZ5maPXbVOv5TL8FuABrClpxDj5VVBEf93FShqa9bl_pKbUKCwRZc2oj3w8PZ8'}).then(d => {
      userSetFCMToken(this.token, d);
    });
  },
  mounted() {
    if ("Notification" in window && Notification.permission !== "granted" && Notification.permission !== "denied") {

      this.$swal({
        title: this.$t("body.notifications"),
        text: this.$t("body.notificationWebConfirm"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t("body.allow"),
        cancelButtonText: this.$t("newPolRequest.dahaSonra")
      }).then((result) => {
        if (result.value) {
          Notification.requestPermission().then((permission) => {
            // If the user accepts, let's create a notification
            if (permission === "granted") {
              new Notification("Scc.az", {
                body: this.$t("body.szArtqBldrlsAlaq")
              });
            }
          });
        }
      });
      // We need to ask the user for permission

    }

    this.checkSectorUpdateNeeded();
  },
  methods: {
    sidebar_toggle(value) {
      this.sidebar_toggle_var = !value
    },
    rightsidebar_toggle(value) {
      this.rightsidebar_toggle_var = value
    },
    mobiletoggle_toggle(value) {
      this.mobileheader_toggle_var = value
    },
    handleResize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },
    sendFeedback() {

      let device = JSON.stringify(getBrowserInfo());

      sendFeedbackRequest(this.token, 'web', device, this.feedBackText).then(data => {
        if (data.code === 200) {
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: this.$t("body.srgnzUgrlGndrl"),
            icon: 'success'
          }).then(() => {
            if (this.$route.name === 'feedback') {
              window.location.reload();
            }
          });
          this.$bvModal.hide('modal-feedback-form');


        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    },


    needOtherProfile(profiles) {
      this.needProfiles = profiles;
      this.$bvModal.show('modal-change-account');
    },

    checkSectorUpdateNeeded() {


    }
  }
}
</script>
